import CrossFilledIcon from '@shared/assets/icons/cross/filled.svg';
import NotificationEnabledIcon from '@shared/assets/icons/notification/enabled.svg';
import PlusFilledIcon from '@shared/assets/icons/plus/filled.svg';
import { type MBImageURISource } from '@shared/components/image';
import { Colors } from '@shared/styles';
import { type API } from '@shared/types/api';

const iconColorByMessageType: Partial<Record<API.EntityEventType, string>> = {
  CARD_CREATED: Colors.blue.light,
  CARD_UPDATED: Colors.blue.light,
  CARD_DELETED: Colors.red.primary,
  CARD_REMINDER_SENT: Colors.red.primary,
};

const iconByMessageType: Partial<Record<API.EntityEventType, MBImageURISource>> = {
  CARD_CREATED: PlusFilledIcon,
  CARD_UPDATED: PlusFilledIcon,
  CARD_DELETED: CrossFilledIcon,
  CARD_REMINDER_SENT: NotificationEnabledIcon,
};

export function getIconColor(message: API.ChatMessageFragment): string {
  return iconColorByMessageType[message.subType ?? ''] as string;
}

export function getIcon(message: API.ChatMessageFragment): MBImageURISource {
  return iconByMessageType[message.subType ?? ''] as MBImageURISource;
}
